import {
  ChangeDetectorRef,
  Component,
  OnInit,
} from "@angular/core";
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbDatepickerConfig, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { GroupMasterService } from "../../../services/group-master.service";
import { TaskService } from "../../../services/task.service";
import { UserMasterService } from "../../../services/user-master.service";
import { ProcessMasterService } from "../../../services/process-master.service";
import { ActivatedRoute } from "@angular/router";
import { Enums } from "../../../helpers/enums";
import { CommonFunction } from "../../../helpers/commonFunction";
import { AlertComponent } from "../../../structure/alert/alert.component";
import { CustomValidation } from "../../../helpers/customValidation";
import { Location } from '@angular/common';
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
var moment = require("moment");

import * as _ from "lodash";

declare var $: any;
declare var jQuery: any;
declare var autosize: any;
import { environment } from "../../../../environments/environment";
import { SharerService } from "../../../services/sharer.service";
import { UserTeamMasterService } from "../../../services/user-team-master.service";
import { LoaderService } from "src/app/services/loader.service";


@Component({
  selector: "app-addtask",
  templateUrl: "./add-task.component.html",
  styleUrls: ["./add-task.component.css"],
})
export class AddTaskComponent implements OnInit {
  public environmentSettings: any;
  combineArray: any[] = [];
  taskForm: FormGroup;
  consequenceMode: 'system' | 'user' = 'user';
  tasks: any[];
  meetingTypes: any[];
  groupTypes: any[];
  taskId: string;
  meetingtypeId: string;
  meetingType: string;
  groupId: string;
  groupName: string;
  policyTypes: any[];
  riskTypes: any[];
  dateOptions: any[];
  departments: any[];
  users: any[];
  listOfFiles: any[] = [];
  assignedusers: any[];
  escalation2Users: any[];
  escalation1Users: any[];
  escalation1ofResponsibleUsers: any[];
  escalation2ofResponsibleUsers: any[];
  responsibleUsers: any[];
  responsibleUsers2: any[];
  filesToUpload: any;
  collegues: any[];
  taskTriggerTypes: any[];
  policytypeId: string;
  risktypeId: string;
  TriggerStartingDateModel: NgbDateStruct;
  EndDateModel: NgbDateStruct;
  ReminderDateModel: NgbDateStruct;
  CompletionDateModel: NgbDateStruct;
  triggerType: string;
  processType: string;
  tasktriggerId: string;
  ProcessIdModel: any;
  afterTriggerDate: NgbDateStruct;
  processes: any[];
  processId: string;
  numList: Array<string> = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
  taskParticularsmodel: string;
  ReminderDays: any;
  CompletionDays: any;
  todaysDate: any;
  checkValidationInput: any;
  error: any = { isError: false, errorMessage: "" };
  reminderFrequencyError: any = { isError: false, errorMessage: "" };
  firstEscalationStartError: any = { isError: false, errorMessage: "" };
  secondEscalationStartError: any = { isError: false, errorMessage: "" };
  firstEscalationreminderFrequencyError: any = {
    isError: false,
    errorMessage: "",
  };
  secondEscalationreminderFrequencyError: any = {
    isError: false,
    errorMessage: "",
  };
  isEscalationExpanded: boolean = false;
  removeuserid: any;
  isPeriodicConfigurationAvailable: boolean = true;
  configAssignedUserId: any;
  disabledOnclick: boolean = false;
  fixedDateDateModel: NgbDateStruct;
  tempCollegues: any[];
  tempEscalation1Users: any[];
  tempAssignedusers: any[];
  tempEscalation2Users: any[];
  public ipLocalPc: any;
  taskUpdateType: any;
  userTeamData: any = [];
  selectedUsers: any = [];
  fileList: File[] = [];
  fileNameArray: any[] = [];
  date = new Date();
  timestamp: any;
  isCheckerRole: boolean = false;
  isApplyingTaskTemplate: boolean = false;
  lastTemplateTaskName: string | null = null;
  isSavingTask: boolean = false;
  constructor(
    private loaderService: LoaderService,
    config: NgbDatepickerConfig,
    private userteammasterService: UserTeamMasterService,
    private userMasterService: UserMasterService,
    private taskService: TaskService,
    private processService: ProcessMasterService,
    private groupMasterService: GroupMasterService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private customValidation: CustomValidation,
    private commonFunction: CommonFunction,
    private alert: AlertComponent,
    private sharerService: SharerService,
    private location: Location
  ) {
    this.dateOptions = Enums.DateOptions;
    this.policyTypes = this.commonFunction.sortByKey(Enums.policyType, "name");
    this.riskTypes = this.commonFunction.sortByKey(Enums.RiskTypes, "name");
    this.departments = this.commonFunction.sortByKey(Enums.Departments, "name");
    this.getUsersMaster();
  }

  getUsersMaster() {
    this.userteammasterService
      .getUserTeamMasterData()
      .subscribe((userMasterData) => {
        this.userTeamData = userMasterData.userDataList;
      });
  }

  getMeetingTypeList() {
    this.meetingTypes = [];
    this.taskService.getMeetingTypeList().subscribe((meetingTypeList) => {
      if (meetingTypeList.status == 0) {
        this.meetingTypes = meetingTypeList.meetingTypeList;
      }
    });
  }

  getGroupmasterList() {
    this.groupTypes = [];
    this.groupMasterService.getGroupList()
      .subscribe((groupList: any) => {
        if (groupList.status == 0) {
          this.groupTypes = this.commonFunction.sortByKey(groupList.groupList, 'GroupName');
        }
      })
  }

  async pasteTaskFromClipboard(): Promise<void> {
    if (this.isApplyingTaskTemplate) {
      return;
    }

    let reference = '';

    if (navigator.clipboard && navigator.clipboard.readText) {
      try {
        reference = (await navigator.clipboard.readText())?.trim();
      } catch (error) {
        console.warn('Clipboard read failed', error);
      }
    }

    if (!reference) {
      reference = (window.prompt('Paste the task link or ID you copied from the task list:') || '').trim();
    }

    if (!reference) {
      this.alert.error('Clipboard is empty. Please copy a task link from the task list first.');
      return;
    }

    this.loadTaskTemplate(reference);
  }

  private loadTaskTemplate(reference: string): void {
    const taskId = this.extractTaskId(reference);
    if (!taskId) {
      this.alert.error('Please paste a valid task link or ID.');
      return;
    }

    this.isApplyingTaskTemplate = true;
    this.loaderService.enable();
    this.taskService.getPredefinedTaskByTaskId(taskId).subscribe(
      (response: any) => {
        this.loaderService.disable();
        this.isApplyingTaskTemplate = false;

        const task = response?.taskData?.[0];
        if (response?.status !== 0 || !task) {
          this.alert.error('Unable to load the selected task. Please verify the link.');
          return;
        }

        this.populateTaskFormFromTemplate(task);
        this.lastTemplateTaskName = task.TaskName || null;
        this.alert.success('Task details pasted successfully. Review and save to create a new task.');
      },
      (error) => {
        this.loaderService.disable();
        this.isApplyingTaskTemplate = false;
        this.alert.error(error?.error?.message || error?.message || 'Unable to paste the selected task.');
      }
    );
  }

  private extractTaskId(reference: string): string | null {
    if (!reference) {
      return null;
    }

    const trimmed = reference.trim();
    const idMatch = trimmed.match(/([a-fA-F0-9]{24})/);
    if (idMatch && idMatch[1]) {
      return idMatch[1];
    }

    if (/^[a-zA-Z0-9_-]{10,}$/.test(trimmed)) {
      return trimmed;
    }

    return null;
  }

  private populateTaskFormFromTemplate(task: any): void {
    const triggerTypeLabel = task.TriggerType === 2 ? 'Periodic' : 'Event';
    const isGlobalValue = task.IsGlobal ? 'Global' : 'Company';

    this.taskForm.patchValue({
      TaskName: task.TaskName || '',
      TaskDescription: task.TaskDescription || '',
      IsGlobal: isGlobalValue,
      Email: task.EmailSendForTask !== undefined ? task.EmailSendForTask : true,
      groupId: task.GroupID || '',
      meetingtypeId: task.MeetingTypeID || '',
      ReminderDays: task.ReminderDays ?? null,
      ReminderFrequency: task.ReminderPeriod ?? null,
      EscalationDays: task.EscalationDays ?? null,
      Level2EscalationDays: task.Level2EscalationDays ?? null,
      ReminderFrequencyLevel1: task.ReminderPeriodLevel1 ?? null,
      ReminderFrequencyLevel2: task.ReminderPeriodLevel2 ?? null,
      CompletionDays: task.CompletionDays ?? null,
      EmailContents: task.EmailContents || '',
      policytypeId: task.PolicyType !== undefined ? String(task.PolicyType) : this.taskForm.controls.policytypeId.value,
      risktypeId: task.RiskType !== undefined ? String(task.RiskType) : this.taskForm.controls.risktypeId.value,
      DateOption: task.DateOption ? String(task.DateOption) : this.taskForm.controls.DateOption.value,
      PreConsequences: task.PreConsequences || '',
      UserConsequences: task.UserConsequences || '',
      AssignedTo: this.coerceArray(task.AssignedTo),
      ResponsibleUser: this.coerceArray(task.ResponsibleUser),
      Escalation1ofAssignedTo: this.coerceArray(task.Escalation1ofAssignedTo),
      Escalation2ofAssignedTo: this.coerceArray(task.Escalation2ofAssignedTo),
      Escalation1ofResponsibleUser: this.coerceArray(task.Escalation1ofResponsibleUser),
      Escalation2ofResponsibleUser: this.coerceArray(task.Escalation2ofResponsibleUser),
      Collegues: this.coerceArray(task.Collegues),
      ProcessID: task.ProcessID || task.ProcessId || '',
      TaskParticulars: task.TaskParticulars || ''
    }, { emitEvent: false });

    this.taskForm.controls.TriggerType.setValue(triggerTypeLabel);
    this.CheckTriggerType(triggerTypeLabel);
    this.taskForm.controls.tasktriggerId.setValue(task.TriggerID || '');

    const consequenceMode: 'system' | 'user' = task.IsPredefined ? 'system' : 'user';
    this.setConsequenceMode(consequenceMode);
    if (consequenceMode === 'system') {
      this.taskForm.controls.PreConsequences.setValue(task.PreConsequences || '', { emitEvent: false });
    } else {
      this.taskForm.controls.UserConsequences.setValue(task.UserConsequences || '', { emitEvent: false });
    }

    this.clearDateFields();

    this.taskForm.markAsDirty();
    this.updateReminderDays();
  }

  private coerceArray(value: any): any[] {
    if (!value) {
      return [];
    }
    return Array.isArray(value) ? value : [value];
  }

  private clearDateFields(): void {
    const dateControls = ['TriggerStartingDate', 'fixedDate', 'endDate', 'ReminderDate', 'CompletionDate'];
    dateControls.forEach(control => {
      this.taskForm.controls[control]?.setValue(null, { emitEvent: false });
    });

    this.TriggerStartingDateModel = null;
    this.fixedDateDateModel = null;
    this.EndDateModel = null;
    this.ReminderDateModel = null;
    this.CompletionDateModel = null;
  }
  onFileChanged(event: any) {
    for (var i = 0; i <= event.target.files.length - 1; i++) {
      this.filesToUpload = event.target.files[i];
      let fileObj = {
        target: {
          files: [this.filesToUpload]
        }
      }
      if (this.commonFunction.checkFileExtension(fileObj)) {

        var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect(fileObj, fileObj)
        if (filenameValidation == "Valid") {
          this.fileList.push(this.filesToUpload);
          this.listOfFiles.push(this.filesToUpload.name);
        } else {
          this.alert.error(filenameValidation);
        }
      } else {
        this.alert.error("Invalid file extension")
      }
    }
  }

  changeTrigger() {
    this.afterTriggerDate = this.taskForm.controls.TriggerStartingDate.value;
  }

  getProcessList() {
    this.processes = [];

    this.processService.getProcessList().subscribe((processList) => {
      if (processList.status == 0) {
        this.processes = processList.processList;
      }
    });
  }

  showTaskParticulars() {
    this.taskForm.controls.TaskParticulars.setValidators([
      Validators.required,
      this.customValidation.noWhitespaceValidator,
    ]);
    this.taskForm.controls.TaskParticulars.updateValueAndValidity();
  }

  showaddProcessDialog() {

    this.taskForm.controls.ProcessID.setValidators([Validators.required]);
    this.taskForm.controls.ProcessID.updateValueAndValidity();
    this.taskForm.controls.ProcessID.setValue("");
  }

  removeTaskParticularsvalidation() {
    this.taskForm.controls.TaskParticulars.clearValidators();
    this.taskForm.controls.TaskParticulars.updateValueAndValidity();
  }

  removeProcessvalidation() {
    this.taskForm.controls.ProcessID.clearValidators();
    this.taskForm.controls.ProcessID.updateValueAndValidity();
  }

  getTaskTriggerTypeList() {
    this.taskTriggerTypes = [];

    this.taskService.getTaskTriggersList().subscribe((tasktriggerList) => {
      if (tasktriggerList.status == 0) {
        this.taskTriggerTypes = tasktriggerList.tasktriggerList;
      }
    });
  }

  getescalation2ResponsibleUsersList() {
    this.escalation2ofResponsibleUsers = [];

    this.taskService.getUsersList().subscribe((result) => {
      if (result.status == 0) {
        if (environment.PSS == true) {
          var userlist = [];
          var usersData = result.result;

          _.forEach(usersData, function (user) {
            var resources = user.Resources;
            var foundResource = resources[0].filter(function (element) {
              return element.Menu === "TaskSpecificUserRoles";
            });

            if (foundResource[0] != undefined) {
              var data = _.find(
                foundResource[0].ChildResources,
                function (Item) {
                  return (
                    Item.ResourceType == "Escalation 2 of Responsible User"
                  );
                }
              );
              if (data != undefined) {
                userlist.push(user);
              }
            }
          });

          this.escalation2ofResponsibleUsers = this.commonFunction.sortByKey(
            userlist,
            "FirstName"
          );
        } else {
          this.escalation2ofResponsibleUsers = this.commonFunction.sortByKey(
            result.result,
            "FirstName"
          );
        }

        this.escalation2ofResponsibleUsers =
          this.escalation2ofResponsibleUsers.map(function (element) {
            return {
              label: element.FirstName + " " + element.LastName,
              value: element._id,
              disabled: element.isDisable,
            };
          });
      }
    });
  }

  onResponsibleUserChange(selectedUsers: any[]) {
    if (selectedUsers?.length) {
      this.addUser(selectedUsers, 'name', 'Active');
    } else {
      this.addUser([], 'name', 'none');
    }
  }

  onEscalation1ofResponsibleUserChange(selectedUsers: any[]) {
    if (selectedUsers?.length) {
      this.addUser(selectedUsers, 'name', 'Active');
    } else {
      this.addUser([], 'name', 'none');
    }
  }

  onEscalation2ofResponsibleUserChange(selectedUsers: any[]) {
    if (selectedUsers?.length) {
      this.addUser(selectedUsers, 'name', 'Active');
    } else {
      this.addUser([], 'name', 'none');
    }
  }


  getescalation1ResponsibleUsersList() {
    this.escalation1ofResponsibleUsers = [];

    this.taskService.getUsersList().subscribe((result) => {
      if (result.status == 0) {
        if (environment.PSS == true) {
          var userlist = [];
          var usersData = result.result;

          _.forEach(usersData, function (user) {
            var resources = user.Resources;
            var foundResource = resources[0].filter(function (element) {
              return element.Menu === "TaskSpecificUserRoles";
            });

            if (foundResource[0] != undefined) {
              var data = _.find(
                foundResource[0].ChildResources,
                function (Item) {
                  return (
                    Item.ResourceType == "Escalation 1 of Responsible User"
                  );
                }
              );
              if (data != undefined) {
                userlist.push(user);
              }
            }
          });

          this.escalation1ofResponsibleUsers = this.commonFunction.sortByKey(
            userlist,
            "FirstName"
          );
        } else {
          this.escalation1ofResponsibleUsers = this.commonFunction.sortByKey(
            result.result,
            "FirstName"
          );
        }

        this.escalation1ofResponsibleUsers =
          this.escalation1ofResponsibleUsers.map(function (element) {
            return {
              label: element.FirstName + " " + element.LastName,
              value: element._id,
              disabled: element.isDisable,
            };
          });
      }
    });
  }

  getescalation1UsersList() {
    this.escalation1Users = [];

    this.taskService.getUsersList().subscribe((result) => {
      if (result.status == 0) {
        if (environment.PSS == true) {
          var userlist = [];
          var usersData = result.result;

          _.forEach(usersData, function (user) {
            var resources = user.Resources;
            var foundResource = resources[0].filter(function (element) {
              return element.Menu === "TaskSpecificUserRoles";
            });

            if (foundResource[0] != undefined) {
              var data = _.find(
                foundResource[0].ChildResources,
                function (Item) {
                  return Item.ResourceType == "Escalation 1";
                }
              );
              if (data != undefined) {
                userlist.push(user);
              }
            }
          });

          this.escalation1Users = this.commonFunction.sortByKey(
            userlist,
            "FirstName"
          );
        } else {
          this.escalation1Users = this.commonFunction.sortByKey(
            result.result,
            "FirstName"
          );
        }
        this.escalation1Users = this.escalation1Users.map(function (element) {
          return {
            label: element.FirstName + " " + element.LastName,
            value: element._id,
            disabled: element.isDisable,
          };
        });
        this.tempEscalation1Users = this.escalation1Users;
      }
    });
  }

  getescalation2UsersList() {
    this.escalation2Users = [];

    this.taskService.getUsersList().subscribe((result) => {
      if (result.status == 0) {
        if (environment.PSS == true) {
          var userlist = [];
          var usersData = result.result;

          _.forEach(usersData, function (user) {
            var resources = user.Resources;
            var foundResource = resources[0].filter(function (element) {
              return element.Menu === "TaskSpecificUserRoles";
            });

            if (foundResource[0] != undefined) {
              var data = _.find(
                foundResource[0].ChildResources,
                function (Item) {
                  return Item.ResourceType == "Escalation 2";
                }
              );
              if (data != undefined) {
                userlist.push(user);
              }
            }
          });

          this.escalation2Users = this.commonFunction.sortByKey(
            userlist,
            "FirstName"
          );
        } else {
          this.escalation2Users = this.commonFunction.sortByKey(
            result.result,
            "FirstName"
          );
        }
        this.escalation2Users = this.escalation2Users.map(function (element) {
          return {
            label: element.FirstName + " " + element.LastName,
            value: element._id,
            disabled: element.isDisable,
          };
        });
        this.tempEscalation2Users = this.escalation2Users;
      }
    });
  }

  getassignedUsersList() {
    this.assignedusers = [];

    this.taskService.getUsersList().subscribe((result) => {
      if (result.status == 0 && result.result) {
        let userlist = [];

        if (environment.PSS == true) {
          const usersData = result.result;

          // Filter users with TaskSpecificUserRoles permission
          userlist = usersData.filter(user => {
            if (!user.Resources || !Array.isArray(user.Resources[0])) {
              return false;
            }

            const foundResource = user.Resources[0].find(element =>
              element.Menu === "TaskSpecificUserRoles"
            );

            if (!foundResource || !foundResource.ChildResources) {
              return false;
            }

            const hasAssignedToRole = foundResource.ChildResources.some(item =>
              item.ResourceType === "Assigned to"
            );

            return hasAssignedToRole;
          });
        } else {
          // For non-PSS, use all users
          userlist = result.result;
        }

        // Sort and format users for ng-select
        this.assignedusers = this.commonFunction.sortByKey(userlist, 'FirstName')
          .map(element => ({
            label: `${element.FirstName} ${element.LastName}`,
            value: element._id,
            disabled: false
          }));

        // Store a copy for filtering
        this.tempAssignedusers = [...this.assignedusers];
      }
    });
  }

  getresponsibleUsersList() {
    this.responsibleUsers = [];

    this.taskService.getUsersList().subscribe((result) => {
      if (result.status == 0) {
        if (environment.PSS == true) {
          var userlist = [];
          var usersData = result.result;

          _.forEach(usersData, function (user) {
            var resources = user.Resources;
            var foundResource = resources[0].filter(function (element) {
              return element.Menu === "TaskSpecificUserRoles";
            });

            if (foundResource[0] != undefined) {
              var data = _.find(
                foundResource[0].ChildResources,
                function (Item) {
                  return Item.ResourceType == "Responsible User";
                }
              );
              if (data != undefined) {
                userlist.push(user);
              }
            }
          });

          this.responsibleUsers = this.commonFunction.sortByKey(
            userlist,
            "FirstName"
          );
        } else {
          this.responsibleUsers = this.commonFunction.sortByKey(
            result.result,
            "FirstName"
          );
        }
        this.responsibleUsers = this.responsibleUsers.map(function (element) {
          return {
            label: element.FirstName + " " + element.LastName,
            value: element._id,
            disabled: element.isDisable,
          };
        });
      }
    });
  }

  getUsersList() {
    this.users = [];

    this.taskService.getUsersList().subscribe((result) => {
      if (result.status == 0) {
        this.users = this.commonFunction.sortByKey(result.result, "FirstName");
        for (let i in this.users) {
          this.users[i].isDisable = false;
        }
      }
    });
  }

  getColleguesList() {
    this.collegues = [];

    this.taskService.getUsersList().subscribe((result) => {
      if (result.status == 0 && result.result) {
        let userlist = [];

        if (environment.PSS == true) {
          const usersData = result.result;

          // Filter users with TaskSpecificUserRoles permission
          userlist = usersData.filter(user => {
            if (!user.Resources || !Array.isArray(user.Resources[0])) {
              return false;
            }

            const foundResource = user.Resources[0].find(element =>
              element.Menu === "TaskSpecificUserRoles"
            );

            if (!foundResource || !foundResource.ChildResources) {
              return false;
            }

            const hasColleagueRole = foundResource.ChildResources.some(item =>
              item.ResourceType === "Colleague"
            );

            return hasColleagueRole;
          });
        } else {
          // For non-PSS, use all users
          userlist = result.result;
        }

        // Sort and format users for ng-select
        this.collegues = this.commonFunction.sortByKey(userlist, 'FirstName')
          .map(element => ({
            label: `${element.FirstName} ${element.LastName}`,
            value: element._id,
            disabled: false
          }));

        // Store a copy for filtering
        this.tempCollegues = [...this.collegues];
      }
    });
  }

  onChange(value) {
  }


  onSelectMemberDisableFromOther(status = false) {
    const colleguesToId = this.taskForm.controls["Collegues"].value || [];
    const assignedToId = this.taskForm.controls["AssignedTo"].value || [];
    const escalation1ofAssignedTo = this.taskForm.controls["Escalation1ofAssignedTo"].value || [];
    const escalation2ofAssignedTo = this.taskForm.controls["Escalation2ofAssignedTo"].value || [];

    this.assignedusers = this.tempAssignedusers.map((element) => {
      colleguesToId.indexOf(element.value) < 0 &&
        escalation1ofAssignedTo.indexOf(element.value) < 0 &&
        escalation2ofAssignedTo.indexOf(element.value) < 0;
      return element;
    });

    const colleag: any[] = [];
    const escalation2Users: any[] = [];
    const escalation1Users: any[] = [];

    const tempIds: any[] = [];
    const tempIds1: any[] = [];
    const tempIds2: any[] = [];
    const selectedList: any[] = [];

    this.selectedUsers = [
      ...colleguesToId,
      ...assignedToId,
      ...escalation1ofAssignedTo,
      ...escalation2ofAssignedTo
    ];

    this.userTeamData.forEach((ele) => {
      if (assignedToId.includes(ele.userId)) {
        if (!selectedList.includes(ele.userId)) {
          selectedList.push(ele.userId);
        }

        ele.colleague.forEach((ele1) => {
          if (
            ele1.userId &&
            !assignedToId.includes(ele1.userId) &&
            !tempIds.includes(ele1.userId) &&
            !escalation1ofAssignedTo.includes(ele1.userId) &&
            !escalation2ofAssignedTo.includes(ele1.value)
          ) {
            tempIds.push(ele1.userId);
            colleag.push({ label: ele1.userName, value: ele1.userId });
          }

          if (this.selectedUsers.includes(ele1.userId) && !selectedList.includes(ele1.userId)) {
            selectedList.push(ele1.userId);
          }
        });

        ele.escalation2.forEach((ele1) => {
          if (
            ele1.userId &&
            !assignedToId.includes(ele1.userId) &&
            !tempIds1.includes(ele1.userId) &&
            !colleguesToId.includes(ele1.userId) &&
            !escalation1ofAssignedTo.includes(ele1.value)
          ) {
            tempIds1.push(ele1.userId);
            escalation2Users.push({ label: ele1.userName, value: ele1.userId });
          }

          if (this.selectedUsers.includes(ele1.userId) && !selectedList.includes(ele1.userId)) {
            selectedList.push(ele1.userId);
          }
        });

        ele.escalation1.forEach((ele1) => {
          if (
            ele1.userId &&
            !assignedToId.includes(ele1.userId) &&
            !tempIds2.includes(ele1.userId) &&
            !colleguesToId.includes(ele1.userId) &&
            !escalation2ofAssignedTo.includes(ele1.value)
          ) {
            tempIds2.push(ele1.userId);
            escalation1Users.push({ label: ele1.userName, value: ele1.userId });
          }

          if (this.selectedUsers.includes(ele1.userId) && !selectedList.includes(ele1.userId)) {
            selectedList.push(ele1.userId);
          }
        });
      }
    });

    if (escalation2Users.length === 0 && escalation2ofAssignedTo.length > 0) {
      escalation2ofAssignedTo.forEach((ele) => {
        escalation2Users.push({ value: ele });
      });
    }

    if (escalation1Users.length === 0 && escalation1ofAssignedTo.length > 0) {
      escalation1ofAssignedTo.forEach((ele) => {
        escalation1Users.push({ value: ele });
      });
    }

    const colleagData = _.without(
      colleag.map((ele) => ele.value),
      ...((escalation1Users || []).map((ele) => ele.value)),
      ...((escalation2Users || []).map((ele) => ele.value))
    );

    const escalationData = _.without(
      escalation1Users.map((ele) => ele.value),
      ...colleagData,
      ...((escalation2Users || []).map((ele) => ele.value))
    );

    const escaltion2Data = _.without(
      escalation2Users.map((ele) => ele.value),
      ...colleagData,
      ...escalationData
    );

    this.collegues = this.tempCollegues.filter(
      (element) =>
        (!assignedToId.includes(element.value) &&
          !escalation1ofAssignedTo.includes(element.value) &&
          !escalation2ofAssignedTo.includes(element.value)) ||
        colleguesToId.includes(element.value)
    );

    this.escalation1Users = this.tempEscalation1Users.filter(
      (element) =>
        (!assignedToId.includes(element.value) &&
          !colleguesToId.includes(element.value) &&
          !escalation2ofAssignedTo.includes(element.value)) ||
        escalation1ofAssignedTo.includes(element.value)
    );

    this.escalation2Users = this.tempEscalation2Users.filter(
      (element) =>
        (!assignedToId.includes(element.value) &&
          !colleguesToId.includes(element.value) &&
          !escalation1ofAssignedTo.includes(element.value)) ||
        escalation2ofAssignedTo.includes(element.value)
    );

    // if (status) {
    //   this.taskForm.controls["Collegues"].setValue(colleagData);
    //   this.taskForm.controls["Escalation1ofAssignedTo"].setValue(escalationData);
    //   this.taskForm.controls["Escalation2ofAssignedTo"].setValue(escaltion2Data);
    // }
  }


  selectUserTeam(assignedUserId) {
    this.taskService
      .getUserDetailsByAssignedUser(assignedUserId.value)
      .subscribe((response) => {
        if (response.data.length > 0) {
          this.taskForm.controls.Escalation2ofAssignedTo.setValue(
            response.data[0].escalation2.userId
          );
          this.taskForm.controls.Escalation1ofAssignedTo.setValue(
            response.data[0].escalation1.userId
          );
          this.taskForm.controls.Collegues.setValue(
            response.data[0].colleague.userId
          );

        } else {
          this.taskForm.controls.Escalation2ofAssignedTo.setValue(null);
          this.taskForm.controls.Escalation1ofAssignedTo.setValue(null);
          this.taskForm.controls.Collegues.setValue(null);
        }
      });
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  getTriggerTypeListByTriggerType(triggerType) {
    this.taskTriggerTypes = [];

    this.taskService
      .getTriggerTypeListByTriggerType(triggerType)
      .subscribe((tasktriggerList) => {
        if (tasktriggerList.status == 0) {
          this.taskTriggerTypes = tasktriggerList.tasktriggerList;
          // Set "Fixed Date" as default if trigger type is "Event" and tasktriggerId is empty
          if (triggerType === 'Event' && this.taskForm) {
            const currentTriggerId = this.taskForm.controls.tasktriggerId.value;
            // Only set default if the value is empty or not set
            if (!currentTriggerId || currentTriggerId === '') {
              const fixedDateId = "5eb94ca3ffaa93751ec4f387";
              // Check if Fixed Date exists in the list
              const fixedDateExists = this.taskTriggerTypes.some(trigger => trigger._id === fixedDateId);
              if (fixedDateExists) {
                this.taskForm.controls.tasktriggerId.setValue(fixedDateId);
                // Trigger change detection multiple times to ensure the view updates
                setTimeout(() => {
                  this.cdRef.detectChanges();
                }, 0);
                setTimeout(() => {
                  this.cdRef.detectChanges();
                }, 100);
              }
            }
          }
        }
      });
  }

  setConsequenceMode(mode: 'system' | 'user') {
    if (!this.taskForm) {
      this.consequenceMode = mode;
      return;
    }
    this.consequenceMode = mode;
    const preControl = this.taskForm.controls.PreConsequences;
    const userControl = this.taskForm.controls.UserConsequences;
    if (mode === 'system') {
      preControl.enable();
      userControl.setValue('');
      userControl.disable();
      this.taskForm.controls.IsPredefinedorUserdefined.setValue('Predefined');
      this.CheckProcessType('Predefined');
    } else {
      userControl.enable();
      preControl.setValue('');
      preControl.disable();
      this.taskForm.controls.IsPredefinedorUserdefined.setValue('Userdefined');
      this.CheckProcessType('Userdefined');
    }
  }

  getProcessListByProcessType(processType) {
    this.processes = [];
    var ispredefined = null;
    if (processType === "Predefined") {
      ispredefined = true;
    } else if (processType === "Userdefined") {
      ispredefined = false;
    }

    this.processService.getProcessList().subscribe((processList) => {
      if (processList.status == 0) {
        var processData = $(processList.processList).filter(function (i, n) {
          return n.IsPredefined === ispredefined;
        });
        this.processes = this.commonFunction.sortByKey(
          processData,
          "ProcessName"
        );
      }
    });
    this.taskForm.controls.ProcessID.setValue("");
  }

  setDate(date) {
    return this.commonFunction.setDate(date);
  }

  ShowCompanyTasks() {
    this.ngOnInit();
    this.location.back(); // Navigate back to the previous page
  }

  GetTaskFormInput() {
    this.updateReminderDays();
    if (this.taskForm.status == "VALID") {
      var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
      var companyID = companyDetails.companyID;
      var checkGlobal = true;
      this.timestamp = this.date.getTime();
      var companyId;
      if (this.taskForm.controls.IsGlobal.value == "Company") {
        checkGlobal = false;
        companyId = companyID;
      } else {
        companyId = null;
      }
      var checkTasktrigger = null;
      if (this.taskForm.controls.TriggerType.value == "Event") {
        checkTasktrigger = 1;
      }
      if (this.taskForm.controls.TriggerType.value == "Periodic") {
        checkTasktrigger = 2;
      }

      var processId = null;
      if (this.taskForm.controls.ProcessID.value != "") {
        processId = this.taskForm.controls.ProcessID.value;
      }
      let approveStatus = true;
      if (environment.TaskMakerChecker) {
        approveStatus = false;
      }

      const isSystemDefined = this.consequenceMode === 'system';
      const preConsequences = isSystemDefined
        ? (this.taskForm.controls.PreConsequences.value || '').toString().trim()
        : '';
      const userConsequences = isSystemDefined
        ? ''
        : (this.taskForm.controls.UserConsequences.value || '').toString().trim();

      var newTask = {
        TaskName: this.taskForm.controls.TaskName.value.trim(),
        TaskDescription: this.taskForm.controls.TaskDescription.value.trim(),
        GroupID: this.taskForm.controls.groupId.value,
        IsGlobal: checkGlobal,
        MeetingTypeID:
          this.taskForm.controls.meetingtypeId.value == ""
            ? null
            : this.taskForm.controls.meetingtypeId.value,
        ReminderDays: this.taskForm.controls.ReminderDays.value,
        ReminderPeriod: this.taskForm.controls.ReminderFrequency.value,
        EscalationDays: this.taskForm.controls.EscalationDays.value,
        Level2EscalationDays: this.taskForm.controls.Level2EscalationDays.value,
        CompletionDays:this.taskForm.controls.CompletionDays.value,
        TriggerType: checkTasktrigger,
        TriggerID: this.taskForm.controls.tasktriggerId.value,
        DateOption: parseInt(this.taskForm.controls.DateOption.value),
        EmailSendForTask: this.taskForm.controls.Email.value,
        ReminderPeriodLevel1:
          this.taskForm.controls.ReminderFrequencyLevel1.value,
        ReminderPeriodLevel2:
          this.taskForm.controls.ReminderFrequencyLevel2.value,
        EmailContents: this.taskForm.controls.EmailContents.value,
        PolicyType: parseInt(this.taskForm.controls.policytypeId.value),
        RiskType: parseInt(this.taskForm.controls.risktypeId.value),
        PreConsequences: preConsequences,
        UserConsequences: userConsequences,
        AssignedTo:
          this.taskForm.controls.AssignedTo.value == ""
            ? null
            : this.taskForm.controls.AssignedTo.value,
        ResponsibleUser:
          this.taskForm.controls.ResponsibleUser.value == ""
            ? null
            : this.taskForm.controls.ResponsibleUser.value,
        IsActive: true,
        IsPredefined: isSystemDefined,
        Escalation1ofAssignedTo:
          this.taskForm.controls.Escalation1ofAssignedTo.value == ""
            ? null
            : this.taskForm.controls.Escalation1ofAssignedTo.value,
        Escalation2ofAssignedTo:
          this.taskForm.controls.Escalation2ofAssignedTo.value == ""
            ? null
            : this.taskForm.controls.Escalation2ofAssignedTo.value,
        Escalation1ofResponsibleUser:
          this.taskForm.controls.Escalation1ofResponsibleUser.value == ""
            ? null
            : this.taskForm.controls.Escalation1ofResponsibleUser.value,
        Escalation2ofResponsibleUser:
          this.taskForm.controls.Escalation2ofResponsibleUser.value == ""
            ? null
            : this.taskForm.controls.Escalation2ofResponsibleUser.value,
        Collegues:
          this.taskForm.controls.Collegues.value == ""
            ? null
            : this.taskForm.controls.Collegues.value,
        CompanyID: companyId,
        TriggerStartDate: this.setDate(this.taskForm.controls.TriggerStartingDate.value),
        EndDate: this.setDate(this.taskForm.controls.endDate.value),
        TaskParticulars:
          this.taskForm.controls.TaskParticulars.value != null ||
            this.taskForm.controls.TaskParticulars.value != undefined
            ? this.taskForm.controls.TaskParticulars.value.trim()
            : this.taskForm.controls.TaskParticulars.value,
        ProcessID: processId,
        DefaultAssignedTo: this.configAssignedUserId,
        FixedDate: this.setDate(this.taskForm.controls.fixedDate.value),
        isApproved: approveStatus,
        IPAddress: this.ipLocalPc,
        type: this.taskUpdateType,
        DocumentFile: [] as any,
      };

      this.listOfFiles = this.listOfFiles.map(f => { return `${this.timestamp}-${f}` });

      this.combineArray = this.listOfFiles.concat(this.fileNameArray);
      var removeNullElementFromArray = this.combineArray.filter(function (e) { return e != null; });
      newTask.DocumentFile.push(removeNullElementFromArray);
      newTask.DocumentFile = newTask.DocumentFile.join(',');

      return newTask;
    } else {
      return null;
    }
  }

  addTask(type) {
    this.taskUpdateType = type;
    this.disabledOnclick = true;
    this.isSavingTask = true;
    this.timestamp = this.date.getTime();
    if (this.isPeriodicConfigurationAvailable == true) {
      var taskDetail = this.GetTaskFormInput();
      if (!taskDetail) {
        this.disabledOnclick = false;
        this.isSavingTask = false;
        this.taskForm.markAllAsTouched();
        return;
      }

      var todayDate = moment(new Date()).format("MM-DD-YYYY");
      var triggerStartDate =
        taskDetail.TriggerStartDate != null &&
          taskDetail.TriggerStartDate != undefined
          ? moment(taskDetail.TriggerStartDate).format("MM-DD-YYYY")
          : "";

      if (
        triggerStartDate == todayDate &&
        environment.TaskMakerChecker == false
      ) {
        this.disabledOnclick = false;
        this.isSavingTask = false;
        $("#taskParticularsDialog").modal("toggle");
      } else {
        if (triggerStartDate == todayDate) {
          this.taskUpdateType = "addAndActivate";
        }
        this.taskService.addTask(taskDetail).subscribe((task) => {
          this.disabledOnclick = false;
          this.isSavingTask = false;
          if (task.status == 0) {
            var taskId = task.taskId;
            if (this.filesToUpload) {
              if (this.taskUpdateType == 'add') {
                this.makeFileRequest(environment.pssServerUrl + "predefinedTask/uploadFile/" + taskId, this.timestamp, this.fileList).then((result) => {
                  this.alert.successWithOk1(
                    "Task is added successfully and pending for Checker's approval",
                    () => {
                      $('body').removeClass('modal-open');
                      $('.modal-backdrop').remove();

                      this.router.navigate(['structure', { outlets: { 'structure-outlet': ['libraryTask'] } }]);
                    }
                  );
                })
              }
              else if (this.taskUpdateType == 'addAndActivate') {
                this.makeFileRequest(environment.pssServerUrl + "activatedTask/uploadFile/" + taskId, this.timestamp, this.fileList).then((result) => {
                  this.alert.successWithOk1(
                    "Task is added successfully and pending for Checker's approval",
                    () => {
                      $('body').removeClass('modal-open');
                      $('.modal-backdrop').remove();

                      this.router.navigate(['structure', { outlets: { 'structure-outlet': ['tasks', 'activated'] } }]);
                    });
                })
              }



            } else {
              if (environment.TaskMakerChecker == true) {
                this.alert.successWithOk1(
                  "Task is added successfully and pending for Checker's approval",
                  () => {
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();

                    this.router.navigate(['structure', { outlets: { 'structure-outlet': ['libraryTask'] } }]);
                  });

              }
              else {
                this.alert.successWithOk1(task.message, () => {
                  $('body').removeClass('modal-open');
                  $('.modal-backdrop').remove();

                  this.router.navigate(['structure', { outlets: { 'structure-outlet': ['libraryTask'] } }]);
                });

              }
            }
          } else {
            if (task.err_fields != undefined) {
              this.alert.error(
                JSON.stringify(task.err_fields) +
                " fields are required or invalid."
              );
            } else {
              this.alert.error(task.message);
            }
          }


        });
      }
    } else {
      this.isSavingTask = false;
      this.alert.error("Please add default configurations for periodic tasks");
    }
  }
  sanitizeFileName(name: string): string {
    return name.replace(/ /g, '_'); // Replace spaces only
  }
  makeFileRequest(url: string, params: any, files: Array<File>) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var self = this;
      var xhr = new XMLHttpRequest();
      console.log('files', files)
      for (var i = 0; i < files.length; i++) {
        var requiredName = this.sanitizeFileName(files[i].name);
        formData.append("file", files[i], this.timestamp + "-" + requiredName.replace(',', ''));
      }
      console.log(formData);
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.setRequestHeader('userdetail', this.getUserDetail())
      xhr.setRequestHeader('pssdetail', localStorage.getItem("companyDetails"))
      xhr.send(formData);
    });
  }
  getUserDetail() {
    var user = JSON.parse(localStorage.getItem("user"));
    var resources = JSON.parse(localStorage.getItem("resources"));
    var companyDetails = JSON.parse(localStorage.getItem("companyDetailsGoveva"));
    // var resourcesData = resources.filter(function (item) {
    //   return item.Menu === 'UPSI';
    // })[0]

    // var upsiAdmin;
    // if (resourcesData) {
    //   upsiAdmin = (resourcesData['Menu']) ? true : false
    // } else {
    //   upsiAdmin = false
    // }
    var decrEmailId = this.commonFunction.decrypt(user.EmailId);
    var loginUser = {
      id: user._id,
      firstName: user.FirstName,
      lastName: user.LastName,
      // upsiAdmin: upsiAdmin,
      // EmailId: user.EmailId,
      EmailId: decrEmailId,
      companyDetails: companyDetails,
      title: user.Title
    }
    return JSON.stringify(loginUser);
  }
  addTaskandActivate() {
    this.disabledOnclick = true;
    var taskDetail = this.GetTaskFormInput();
    if (!taskDetail) {
      this.disabledOnclick = false;
      this.taskForm.markAllAsTouched();
      return;
    }
    this.taskService.addandActivateTask(taskDetail).subscribe((task) => {
      this.disabledOnclick = false;
      if (task.status == 0) {
        var taskId = task.taskId;
        if (this.filesToUpload) {
          if (this.taskUpdateType == 'add') {
            this.makeFileRequest(environment.pssServerUrl + "predefinedTask/uploadFile/" + taskId, this.timestamp, this.fileList).then((result) => {
              $("#taskParticularsDialog").modal("hide");
              // this.alert.successWithOk(task.message, "/tasks/activated");
              this.alert.successWithOk1(task.message, () => {
                // this.router.navigate(['structure', { outlets: { 'structure-outlet': ['libraryTask'] } }]);
                this.router.navigate(['structure', { outlets: { 'structure-outlet': ['tasks', 'activated'] } }]);

              });
            })
          }
          else if (this.taskUpdateType == 'addAndActivate') {
            this.makeFileRequest(environment.pssServerUrl + "activatedTask/uploadFile/" + taskId, this.timestamp, this.fileList).then((result) => {
              $("#taskParticularsDialog").modal("hide");
              this.alert.successWithOk1(task.message, () => {
                this.router.navigate(['structure', { outlets: { 'structure-outlet': ['tasks', 'activated'] } }]);

              });
            })
          }
          // this.makeFileRequest(environment.pssUrl + "activatedTask/uploadFile/" + taskId, this.timestamp, this.fileList).then((result) => {

          //   $("#taskParticularsDialog").modal("hide");
          //   this.alert.successWithOk(task.message, "/tasks/activated");              
          //   })
        }
        else {
          $("#taskParticularsDialog").modal("hide");
          this.alert.successWithOk1(task.message, () => {
            this.router.navigate(['structure', { outlets: { 'structure-outlet': ['tasks', 'activated'] } }]);

          });
        }

      } else {
        $("#taskParticularsDialog").modal("hide");
        if (task.err_fields != undefined) {
          this.alert.error(
            JSON.stringify(task.err_fields) + " fields are required or invalid."
          );
        } else {
          this.alert.error(task.message);
        }
      }
    });
  }

  addTasktoProcess() {
    if (this.taskForm.controls.ProcessID.value) {
      this.disabledOnclick = true;
      var taskDetail = this.GetTaskFormInput();
      if (!taskDetail) {
        this.disabledOnclick = false;
        this.isSavingTask = false;
        this.taskForm.markAllAsTouched();
        return;
      }
      this.isSavingTask = true;
      this.taskService.addTask(taskDetail).subscribe((task) => {
        this.disabledOnclick = false;
        this.isSavingTask = false;
        if (task.status == 0) {
          $("#addtasktoprocessDialog").modal("toggle");
          const processId = this.taskForm.controls.ProcessID.value;
          //this.alert.successWithOk(task.message, "/process/edit/" + processId);
          this.alert.successWithOk1(task.message, () => {
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
            this.router.navigate(
              [{ outlets: { 'structure-outlet': ['process', 'edit', processId] } }],
              { relativeTo: this.route.parent });
          });
        } else {
          $("#addtasktoprocessDialog").modal("toggle");
          if (task.err_fields != undefined) {
            this.alert.error(
              JSON.stringify(task.err_fields) +
              " fields are required or invalid."
            );
          } else {
            this.alert.error(task.message);
          }
        }
      });
    } else {
      this.alert.error("Please select Process");
    }
  }

  reset() {
    $("#resetConfirmation").modal("toggle");
  }

  resetFormData() {
    this.taskForm.reset();
    $("#resetConfirmation").modal("toggle");
    this.ngOnInit();
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;

    //codes for 0-9
    if (
      (keyCode > 47 && keyCode < 58) ||
      keyCode == 109 ||
      (keyCode > 95 && keyCode < 106) ||
      (keyCode > 34 && keyCode < 41) ||
      keyCode == 16 ||
      keyCode == 46
    ) {
      if (
        ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) &&
        this.numList.indexOf(ev.key) == -1
      ) {
        ev.preventDefault();
      }
      //restrict up to 2 digits
      if ((ev.target.value + ev.key).length > 5) {
        ev.preventDefault();
      }
    } else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  CheckTriggerType(item: string): void {
    this.triggerType = item;

    const control = this.taskForm.controls['TriggerStartingDate'];

    // Dynamically set required validator only for 'Periodic'
    if (item === 'Periodic') {
      control.setValidators([Validators.required]);
    } else {
      control.clearValidators();
      control.setValue(''); // optional: reset value when not needed
    }

    control.updateValueAndValidity();

    // Additional logic
    this.getTriggerTypeListByTriggerType(this.triggerType);
    this.showSelectedTriggerID(this.triggerType);
    this.getPeriodicTaskConfiguration();
  }


  showSelectedTriggerID(triggertype) {
    // Only clear the trigger ID if the trigger type actually changed
    // Don't clear if it's the same type (e.g., when initializing with 'Event')
    if (this.taskForm && this.taskForm.controls.TriggerType.value && this.taskForm.controls.TriggerType.value != triggertype) {
      this.taskForm.controls.tasktriggerId.setValue("");
    }
  }

  CheckProcessType(item: any) {
    this.processType = item;
    this.getProcessListByProcessType(this.processType);
  }

  IsTriggerTypeSelected(name: any): boolean {
    if (!this.triggerType) {
      // if no radio button is selected, always return false so every nothing is shown
      return false;
    }

    return this.triggerType === name; // if current radio button is selected, return true, else return false
  }

  getGroupId(ID: any) {
    if (ID != "") {
      this.getGroupmasterList();
      this.taskForm.controls.groupId.setValue(ID);
    } else {
      this.getGroupmasterList();
    }
  }

  initialiseJqueryEvents() {
    $(".modal-dialog").draggable({
      handle: ".modal-header",
    });
  }

  getTodaysDate() {
    var newDate = new Date();
    this.todaysDate = {
      year: newDate.getFullYear(),
      month: newDate.getMonth() + 1,
      day: newDate.getDate(),
    };
  }

  checkRemindersValidation() {

    var reminderStartDays =
      this.taskForm.controls.ReminderDays.value != null ||
        this.taskForm.controls.ReminderDays.value != undefined
        ? this.taskForm.controls.ReminderDays.value
        : 0;

    var reminderFrequency =
      this.taskForm.controls.ReminderFrequency.value != null ||
        this.taskForm.controls.ReminderFrequency.value != undefined
        ? this.taskForm.controls.ReminderFrequency.value
        : 0;
    var firstEscalationStart =
      this.taskForm.controls.EscalationDays.value != null ||
        this.taskForm.controls.EscalationDays.value != undefined
        ? this.taskForm.controls.EscalationDays.value
        : 0;
    var secondEscalationStart =
      this.taskForm.controls.Level2EscalationDays.value != null ||
        this.taskForm.controls.Level2EscalationDays.value != undefined
        ? this.taskForm.controls.Level2EscalationDays.value
        : 0;
    var firstEscalationreminderfrequency =
      this.taskForm.controls.ReminderFrequencyLevel1.value != null ||
        this.taskForm.controls.ReminderFrequencyLevel1.value != undefined
        ? this.taskForm.controls.ReminderFrequencyLevel1.value
        : 0;
    var secondEscalationreminderfrequency =
      this.taskForm.controls.ReminderFrequencyLevel2.value != null ||
        this.taskForm.controls.ReminderFrequencyLevel2.value != undefined
        ? this.taskForm.controls.ReminderFrequencyLevel2.value
        : 0;

    //Created by Roshan --messages not cleared if date is valid
    if (reminderStartDays != "" || reminderStartDays !== null) {
      if (parseInt(reminderStartDays) < parseInt(reminderFrequency)) {
        this.checkValidationInput = true;
        this.reminderFrequencyError = {
          isError: true,
          errorMessage:
            "Reminder frequency cannot be more than reminder start date.",
        };
        return false;
      } else if (parseInt(reminderStartDays) < parseInt(firstEscalationStart)) {
        this.checkValidationInput = true;
        this.firstEscalationStartError = {
          isError: true,
          errorMessage:
            "1st Escalation start cannot be more than Reminder start date.",
        };
        return false;
      } else if (
        parseInt(firstEscalationStart) < parseInt(secondEscalationStart)
      ) {
        this.checkValidationInput = true;
        this.secondEscalationStartError = {
          isError: true,
          errorMessage:
            "2nd Escalation start cannot be more than 1st Escalation start.",
        };
        return false;
      } else if (
        parseInt(firstEscalationStart) <
        parseInt(firstEscalationreminderfrequency)
      ) {
        this.checkValidationInput = true;
        this.firstEscalationreminderFrequencyError = {
          isError: true,
          errorMessage:
            "1st Escalation reminder frequency cannot be more than 1st Escalation start date.",
        };
        return false;
      } else if (
        parseInt(secondEscalationStart) <
        parseInt(secondEscalationreminderfrequency)
      ) {
        this.checkValidationInput = true;
        this.secondEscalationreminderFrequencyError = {
          isError: true,
          errorMessage:
            "2nd Escalation reminder frequency cannot be more than 2nd Escalation start date.",
        };
        return false;
      } else {
        this.checkValidationInput = false;
        this.reminderFrequencyError = {
          isError: false,
          errorMessage: "",
        };
        this.firstEscalationStartError = {
          isError: false,
          errorMessage: "",
        };
        this.secondEscalationStartError = {
          isError: false,
          errorMessage: "",
        };
        this.firstEscalationreminderFrequencyError = {
          isError: false,
          errorMessage: "",
        };
        this.secondEscalationreminderFrequencyError = {
          isError: false,
          errorMessage: "",
        };
      }
    } else this.error = { isError: false, errorMessage: "" };


    return true;
  }

  ngOnInit() {
    let roles = JSON.parse(localStorage.getItem('user')).Roles.map(role => role.RoleName)
    let TaskMaker = roles.includes('Task Checker');
    let TaskMakerAdmin = roles.includes('Admin');
    if (TaskMaker > 0 || TaskMakerAdmin>0) {
      setTimeout(() => {
        this.isCheckerRole = true;
        this.cdRef.detectChanges(); // trigger Angular to update the view
      }, 0);
    } else {
      this.isCheckerRole = false;
    }
    this.loaderService.disable();
    this.environmentSettings = environment;
    this.getescalation2ResponsibleUsersList();
    this.getescalation1ResponsibleUsersList();
    this.getescalation2UsersList();
    this.getescalation1UsersList();
    this.getassignedUsersList();
    this.getresponsibleUsersList();

    this.initialiseJqueryEvents();

    this.getMeetingTypeList();
    this.getGroupmasterList();
    this.getTaskTriggerTypeList();
    this.getUsersList();
    this.getColleguesList();
    this.getProcessList();
    this.getPeriodicTaskConfiguration();

    // this.sharerService.getClientIp().subscribe((response) => {
    //   var ip = JSON.parse(response["_body"]).ip;
    //   this.ipLocalPc = ip;
    // });

    this.taskForm = this.fb.group({
      ReminderDate: [null],
      TaskName: ["", [
        Validators.required,
        this.customValidation.noWhitespaceValidator,
        this.customValidation.inappropriateLanguageValidator.bind(this.customValidation)
      ]],
      TaskDescription: ["", [
        this.customValidation.inappropriateLanguageValidator.bind(this.customValidation)
      ]],
      IsGlobal: ["Company"],
      Email: [true],
      TriggerType: ["Event"],
      groupId: [""],
      meetingtypeId: [""],
      tasktriggerId: [""],
      ReminderDays: [null],
      ReminderFrequency: [null, [
        Validators.pattern("[0-9]*"),
        Validators.maxLength(2),
        Validators.max(30),
        Validators.min(0),
      ]],
      EscalationDays: [null, [
        Validators.pattern("[0-9]*"),
        Validators.maxLength(2),
        Validators.max(30),
        Validators.min(0),
      ]],
      Level2EscalationDays: [null, [
        Validators.pattern("[0-9]*"),
        Validators.maxLength(2),
        Validators.max(30),
        Validators.min(0),
      ]],
      ReminderFrequencyLevel1: [null, [
        Validators.pattern("[0-9]*"),
        Validators.maxLength(2),
        Validators.max(30),
        Validators.min(0),
      ]],
      ReminderFrequencyLevel2: [null, [
        Validators.pattern("[0-9]*"),
        Validators.maxLength(2),
        Validators.max(30),
        Validators.min(0),
      ]],
      CompletionDays: [null],
      CompletionDate: [null],
      EmailContents: [""],
      policytypeId: [""],
      risktypeId: [""],
      DateOption: ["2"],
      PreConsequences: [""],
      UserConsequences: [""],
      AssignedTo: [""],
      ResponsibleUser: [""],
      Escalation1ofAssignedTo: [""],
      Escalation2ofAssignedTo: [""],
      Escalation1ofResponsibleUser: [""],
      Escalation2ofResponsibleUser: [""],
      Collegues: [""],
      TriggerStartingDate: [""],
      endDate: [""],
      TaskParticulars: [""],
      ProcessID: [""],
      IsPredefinedorUserdefined: [""],
      fixedDate: [""],
    });

    this.taskForm.controls.IsGlobal.setValue("Company");
    this.taskForm.controls.Email.setValue(true);
    this.taskForm.controls.policytypeId.setValue("2");
    this.taskForm.controls.risktypeId.setValue("1");
    this.taskForm.controls.ProcessID.setValue("");
    this.taskForm.controls.DateOption.setValue('3');
    // Set default trigger type to Event and initialize related logic
    this.CheckTriggerType('Event');
    // this.taskForm.controls["Escalation2ofResponsibleUser"].disable();
    // this.taskForm.controls["Escalation1ofResponsibleUser"].disable();
    this.taskForm.get('ReminderDate').valueChanges
      .subscribe(() => this.updateReminderDays());

    this.taskForm.get('TriggerStartingDate').valueChanges
      .subscribe(() => this.updateReminderDays());

    this.taskForm.get('fixedDate').valueChanges
      .subscribe(() => this.updateReminderDays());

    this.taskForm.get('DateOption').valueChanges
      .subscribe(() => this.updateReminderDays());

    this.updateReminderDays();

    this.getTodaysDate();

    $("#taskName").focus();
    this.taskForm.patchValue({
      ReminderFrequency: 1,
      EscalationDays: 1,
      Level2EscalationDays: 1,
      ReminderFrequencyLevel1: 1,
      ReminderFrequencyLevel2: 1,
      //CompletionDays:5
    })
    this.taskForm.get('CompletionDate').valueChanges
      .subscribe((date1: any) => {
        let CompletionDays = date1;

        const currentDate = new Date();
        const formattedDate = {
          year: currentDate.getFullYear(),
          month: currentDate.getMonth() + 1, // getMonth() returns 0-based index
          day: currentDate.getDate()
        };
        const currentDate1 = formattedDate;
        let differenceDate = this.getDateDifference(currentDate1, CompletionDays)
        this.taskForm.controls.CompletionDays.setValue(differenceDate);
      });

    this.setConsequenceMode('user');
    // CheckTriggerType('Event') already called above, no need to call again
  }

  /* Periodic task configuration changes (13-03-2019) */

  getPeriodicTaskConfiguration() {
    this.taskService.getPeriodicTaskConfiguration().subscribe((result) => {
      if (
        result.data.length > 0 &&
        this.taskForm.controls.TriggerType.value == "Periodic"
      ) {
        this.isPeriodicConfigurationAvailable = true;
        this.configAssignedUserId =
          result.data[0].PeriodicTaskConfiguration.AssignedUserId;
      } else if (
        result.data.length == 0 &&
        this.taskForm.controls.TriggerType.value == "Periodic"
      ) {
        this.isPeriodicConfigurationAvailable = false;
      } else {
        this.isPeriodicConfigurationAvailable = true;
      }
    });
  }
  getDateDifference(date1: any, date2: any) {
    const startDate = this.toDate(date1);
    const endDate = this.toDate(date2);

    if (!startDate || !endDate) {
      return null;
    }

    return this.calculateDaysBetween(startDate, endDate);
  }

  private updateReminderDays(): void {
    const reminderControl = this.taskForm.get('ReminderDate');
    const reminderDaysControl = this.taskForm.get('ReminderDays');

    if (!reminderControl || !reminderDaysControl) {
      return;
    }

    const reminderDate = this.toDate(reminderControl.value);
    const baseDate = this.toDate(this.getReminderBaseDateValue());

    if (!reminderDate || !baseDate) {
      reminderDaysControl.setValue(null, { emitEvent: false });
      this.clearReminderDateValidationError('reminderBeforeBase');
      return;
    }

    const difference = this.calculateDaysBetween(baseDate, reminderDate);

    if (difference < 0) {
      reminderDaysControl.setValue(null, { emitEvent: false });
      this.setReminderDateValidationError('reminderBeforeBase');
    } else {
      reminderDaysControl.setValue(difference, { emitEvent: false });
      this.clearReminderDateValidationError('reminderBeforeBase');
    }
  }

  private getReminderBaseDateValue(): any {
    const fixedDate = this.taskForm.get('fixedDate')?.value;
    if (this.hasDateValue(fixedDate)) {
      return fixedDate;
    }
    return this.taskForm.get('TriggerStartingDate')?.value;
  }

  private hasDateValue(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }

    if (typeof value === 'string') {
      const normalized = value.trim().toLowerCase();
      return normalized !== '' && normalized !== 'null' && normalized !== 'invalid date';
    }

    return true;
  }

  private toDate(value: any): Date | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (value instanceof Date && !isNaN(value.getTime())) {
      return new Date(value.getTime());
    }

    if (typeof value === 'object' && value.year !== undefined && value.month !== undefined && value.day !== undefined) {
      const year = Number(value.year);
      const month = Number(value.month);
      const day = Number(value.day);
      if (isNaN(year) || isNaN(month) || isNaN(day)) {
        return null;
      }
      return new Date(year, month - 1, day);
    }

    if (typeof value === 'number') {
      const parsedFromNumber = new Date(value);
      return isNaN(parsedFromNumber.getTime()) ? null : parsedFromNumber;
    }

    if (typeof value === 'string') {
      const parsedFromString = new Date(value);
      return isNaN(parsedFromString.getTime()) ? null : parsedFromString;
    }

    return null;
  }

  private calculateDaysBetween(start: Date, end: Date): number {
    const startUTC = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
    const endUTC = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
    return Math.round((endUTC - startUTC) / (1000 * 60 * 60 * 24));
  }

  private setReminderDateValidationError(errorKey: string): void {
    const control = this.taskForm.get('ReminderDate');
    if (!control) {
      return;
    }

    const errors = { ...(control.errors || {}) };
    if (!errors[errorKey]) {
      errors[errorKey] = true;
      control.setErrors(errors);
    }
  }

  private clearReminderDateValidationError(errorKey?: string): void {
    const control = this.taskForm.get('ReminderDate');
    if (!control || !control.errors) {
      return;
    }

    const errors = { ...control.errors };
    if (errorKey) {
      delete errors[errorKey];
    } else {
      Object.keys(errors).forEach(key => delete errors[key]);
    }

    if (Object.keys(errors).length === 0) {
      control.setErrors(null);
    } else {
      control.setErrors(errors);
    }
  }
  addAndActicateCheck(type) {
    this.taskUpdateType = type;

    if (environment.TaskMakerChecker == true) {
      this.addTask("addAndActivate");
    } else {
      if (this.isPeriodicConfigurationAvailable == true) {
        var todatDate = moment().format("YYYY-MM-DD");
        var triggerDate = moment(
          this.taskForm.controls.TriggerStartingDate.value.year +
          "/" +
          this.taskForm.controls.TriggerStartingDate.value.month +
          "/" +
          this.taskForm.controls.TriggerStartingDate.value.day
        ).format("YYYY-MM-DD");

        var remainingDate = moment(triggerDate).diff(todatDate, "days");
        if (remainingDate < 0) {
          this.alert.error(
            "Trigger start date of this task is past date. Please select future date to activate this task."
          );
        } else {
          $("#taskParticularsDialog").modal("toggle");
        }
      } else {
        this.alert.error(
          "Please add default configurations for periodic tasks"
        );
      }
    }
  }

  addUser(e, name, status) { }

  checkTriggerId(triggerId): boolean {
    if (triggerId == "5eb94ca3ffaa93751ec4f387") {
      return true;
    } else {
      return false;
    }
  }
}
